module.exports = __webpack_public_path__ + "static/img/popupDownApp.51ff1c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/popupDownApp.png
// module id = 6/8k
// module chunks = 1